//Custom components
import StatCard from '../../../UI/Card/StatCard';

const MatchingFunds = ({ count }: { count: number }) => {
  return <StatCard title='Matching Funds' stat={`$ ${count}`} />;
};

export default MatchingFunds;
